<template>
<div class="d-flex fullHeight">
    <HelppageSideMenu @set="initialize" class="d-sm-block d-none"/>
    <div class="mainContent mainwindow">
        <div class="p-2">
            <div class="pageTitles">よくある質問</div>
            <div class="cardwindow mt-3 mb-4">
                <div class="accentHelp">
                    <h5 class="font-weight-bold mb-4">マイページの機能に関して</h5>
                    <HelpMenuItem menuTitle="Q．プロフィールを登録したいです。" menuId="4">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「会員情報」をクリックし、「プロフィール登録」をクリックします。</p>
                        <p>4. 年代、スコアレベル、プロフィールを入力し、「登録」ボタンをクリックします。</p>
                        <p>5. 確認ダイアログが表示されますので、「登録」ボタンをクリックして「完了です。」と表示されましたら終了です。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．プロフィールを編集したいです。" menuId="5">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「会員情報」をクリックし、「プロフィール登録」をクリックします。</p>
                        <p>4. 年代、スコアレベル、プロフィールを入力し、「登録」ボタンをクリックします。</p>
                        <p>5. 確認ダイアログが表示されますので、「登録」ボタンをクリックして「完了です。」と表示されましたら終了です。</p>
                    </HelpMenuItem>
                    <!-- クラシック用にコメントアウト -->
                    <!-- <HelpMenuItem menuTitle="Q．LINEアカウントと連携したいです。" menuId="13">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「LINEアカウント連携」をクリックします。</p>
                        <p>4. 「LINEアカウント連携」ボタンをクリックします。</p>
                        <p>5. ページ下部「QRコードログイン」をクリックします。</p>
                        <p>6. QRコードが表示されますので、ご自身のスマートフォンのLINEアプリでQRコードを読み取ります。</p>
                        <p>7. 画面に認証番号が表示されますので、ご自身のスマートフォンのLINEアプリに認証番号を入力します。</p>
                        <p>8. 「会員情報の変更が完了しました。」と表示されましたら終了です。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．LINEアカウントとの連携を解除したいです。" menuId="14">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「LINEアカウント連携解除」をクリックします。</p>
                        <p>4. 「LINEアカウント連携解除」ボタンをクリックします。</p>
                        <p>5. 「LINEアカウントの連携解除が完了しました。」と表示されましたら終了です。</p>
                    </HelpMenuItem> -->
                    <HelpMenuItem menuTitle="Q．お友達の情報を登録したいです。" menuId="9">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「お友達登録」をクリックします。</p>
                        <p>4. ページ下部の「お友達登録」ボタンをクリックします。</p>
                        <p>5. お名前（姓）（名）、メールアドレスを入力し、お友達登録ボタンをクリックします。</p>
                        <p>6. 入力していただいたお名前とメールアドレスが会員様としてご登録されていなかった場合、完了です。（お相手様に会員招待メールを送信します。）</p>
                        <p>7. 入力していただいたお名前とメールアドレスが会員様としてご登録いただいていた場合、お友達申請メールをお相手様に送信します。</p>
                        <p>8. お相手様がメールで承認していただいた時点でお友達として登録されます。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．お友達の情報を編集したいです。" menuId="10">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「お友達登録」をクリックします。</p>
                        <p>4. 該当のお友達の名前をクリックします。</p>
                        <p>5. お名前（姓）（名）、メールアドレスを入力し、お友達編集ボタンをクリックします。</p>
                        <p>6. 入力していただいたお名前とメールアドレスが会員様としてご登録されていなかった場合、完了です。（お相手様に会員招待メールを送信します。）</p>
                        <p>7. 入力していただいたお名前とメールアドレスが会員様としてご登録いただいていた場合、お友達申請メールをお相手様に送信します。</p>
                        <p>8. お相手様がメールで承認していただいた時点でお友達として編集されます。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．お友達の情報を削除したいです。" menuId="11">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「お友達登録」をクリックします。</p>
                        <p>4. 該当のお友達の「削除」ボタンをクリックします。</p>
                        <p>5. 「この友達を削除します。」という確認ダイアログが表示されますので、「削除」をクリックします。</p>
                        <p>6. お友達の情報が一覧から表示されなくなりましたら完了です。</p>
                    </HelpMenuItem>
                    <HelpMenuItem menuTitle="Q．ゴルフ場に対してのお問合せをしたいです。" menuId="12">
                        <p>1. マイページにログインします。</p>
                        <p>2. 画面右上のMENUをクリックし、サイドメニューを開きます。</p>
                        <p>3. 「お問合せ登録」をクリックします。</p>
                        <p>4. お問合せ画面が表示されます。</p>
                        <p>5. 画面下の入力欄にメッセージを入力し、「登録」ボタンをクリックします。</p>
                        <p>6. メッセージ欄にメッセージが表示されたら終了です。</p>
                        <p>※予約に関するお問い合わせは、予約状況一覧にあるお問合せボタンよりメッセージを送信ください。</p>
                    </HelpMenuItem>
                </div>
            </div>
            <HelppageSideMenu @set="initialize" class="d-sm-none"/>
        </div>
    </div>
</div>
</template>


<script>
import HelpMenuItem from './components/HelpMenuItem';
import HelppageSideMenu from './HelppageSideMenu';

export default {
components: {
        HelppageSideMenu,
        HelpMenuItem
    },
    data(){
        return {
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        SigninForm() {
            this.$router.push("/");
        },
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
        }
    }
}
</script>

<style>
 .reserve-img {
     width: 1200px;
 }
 
 @media screen and (max-width: 575px) {
    .reserve-img {
        display: none;
   }
}
</style>
